import { getAuth } from "firebase/auth";
import { firebaseApp } from "../firebase";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:3000";

export async function apiCall<T = unknown>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const auth = getAuth(firebaseApp);
  let token = null;

  if (auth.currentUser) {
    try {
      token = await auth.currentUser.getIdToken(false);
    } catch (error) {
      console.error("Erreur lors de la récupération du token Firebase:", error);
    }
  }

  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: options.method ?? "GET",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: options.body,
  });

  if (!response.ok) {
    let errorMessage = `Request failed with status ${response.status}`;
    try {
      const errorBody = await response.json();
      if (errorBody?.message) errorMessage = errorBody.message;
      if (errorBody?.error) errorMessage = errorBody.error;
    } catch {}
    throw new Error(errorMessage);
  }

  return response.json() as Promise<T>;
}
